/*eslint-disable */
import toast from '@/services/toast';
import { bus } from '@/main';
export default {
  name: 'product-clear-popup',
  components: {},
  props: [],
  data () {
    return {
      submitted:false,
      firstStep:true,
      secondStep:false
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    closeFirstStepPopup(){
      console.log("Chgecking Product")
      this.firstStep = false
      this.secondStep = true
    },
    closePlanStatusChangePopup(){
      bus.$emit('allProductClearStateBus', false)
      document.body.classList.remove('body_right_scroll_remove')
    },
    confirmPlanStatusChangePopup(){
      this.submitted = true
      this.$store.dispatch('allProductClearFunc').then((res) => {
        toast.success('Subscription product is all clear successfully');
        this.submitted =  false
        this.$store.dispatch('getSubscriptionProductListFunc');
        this.closePlanStatusChangePopup();
      })
    }
  }
}